module.exports = __webpack_public_path__ + "img/wenweihai-poster.1149dd9e.jpg";